import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from 'i18next-browser-languagedetector';
// import {initReactI18next} from 'react-i18next'

  // const resources = {
  //   "enUS": {
  //     translation: {}
  //   }
  // };

  // i18n

  //   // pass the i18n instance to react-i18next.
  //   .use(initReactI18next)
  //   // init i18next
  //   // for all options read: https://www.i18next.com/overview/configuration-options
  //   .init({
  //     resources,
  //     fallbackLng: "enUS",
  //     debug: true,      
  //     interpolation: {
  //       escapeValue: false, // not needed for react as it escapes by default
  //     },
  //   });

  // export default i18n;

 
  const fallbackLng = ["en"];
  const availableLanguage = ["en","de"];
  const options = {
    order: ['navigator','htmlTag','path','subdomain'],
    lookupQuerystring: 'lng',
    lookupCookies:'i18next',
    lookupLocalStorage:'i18nextLng',
    lookupFromPathIndex:0,lookupFromSubdomainIndex:0,
    caches : ['localStorage','cookie'],
    excludeCacheFor :['cimode'],
    cookieMinutes:10,
    cookieDomain:'myDomain',
    htmlTag:document.documentElement,
    checkWhitelist : true
  };
  i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng,
    debug:true,
    backend: {
      loadPath: `static/locales/{{lng}}/translation.json`
    },
    whitelist:availableLanguage,
    detection:options,
    interpolation:{
      escapeValue:false
    },

  });

  export default i18n;
  

